// What the person chose in the browser's share picker, and what that allows in
// the pop-out window. Only a window or a tab cannot include the pop-out; the
// whole screen can, and so can a browser that does not say what was picked, so
// that case is treated as the whole screen.

export type ShareSurface = "monitor" | "window" | "browser" | "unknown";

/** The value of a share track's `displaySurface` setting, as a ShareSurface. */
export function classifySurface(raw: unknown): ShareSurface {
  return raw === "monitor" || raw === "window" || raw === "browser" ? raw : "unknown";
}

/** Private cards and host-only lines stay unless the browser does not say what
 * is shared. An entire-screen share keeps them: the host shares his other
 * monitor and keeps the call and notes on the one he is looking at (Adam,
 * 2026-11-01). Null means no share is running. */
export function surfaceKeepsPrivate(surface: ShareSurface | null): boolean {
  return surface !== "unknown";
}

export const UNKNOWN_SURFACE_NOTICE = "This browser does not say what you are sharing. Share a window instead to keep this private.";

/** The one line to show when a share keeps private cards out of the pop-out. */
export function surfaceNotice(surface: ShareSurface | null): string | null {
  if (surface === "unknown") return UNKNOWN_SURFACE_NOTICE;
  return null;
}
